/** Preisherkunft je Auftragsposition — ausschließlich aus dem eingefrorenen Snapshot.
 *  Es werden NIE aktuelle Stammdaten neu aufgelöst. */
import { useI18n } from "@/i18n";

const SRC = ["standard_price", "customer_discount", "price_list", "second_quality",
  "promotion", "manual_override", "external_import", "legacy_unknown"];

export const PriceProvenance = ({ order, money, canSell }) => {
  const { t } = useI18n();
  const lines = order?.lines || [];
  if (!lines.length) return null;
  return (
    <div className="rounded-md border border-border bg-card shadow-sm overflow-hidden" data-testid="price-provenance">
      <div className="px-4 py-3 border-b border-border font-heading font-medium">{t("pv.title")}</div>
      <div className="divide-y divide-border">
        {lines.map((l, i) => {
          const src = SRC.includes(l.pricing_source) ? l.pricing_source : "legacy_unknown";
          return (
            <div key={`${l.variant_id || l.bundle_id || i}-${i}`} className="px-4 py-3 text-sm" data-testid={`provenance-line-${i}`}>
              <div className="flex flex-wrap items-baseline justify-between gap-2">
                <span className="font-medium truncate">{l.name}</span>
                <span className="rounded-full bg-muted px-2 py-0.5 text-xs font-medium" data-testid={`provenance-source-${i}`}>
                  {t(`pv.src.${src}`)}
                </span>
              </div>
              <div className="mt-1 space-y-0.5 text-xs text-muted-foreground">
                {l.base_unit_price != null && (
                  <div>{t("pv.base")}: <span className="font-mono text-foreground">{money(l.base_unit_price)}</span></div>
                )}
                {src === "promotion" && (
                  <>
                    <div data-testid={`provenance-promo-${i}`}>
                      {t("pv.src.promotion")}: <span className="text-foreground">{l.promotion_name_snapshot}</span>
                      {l.promotion_code ? <span className="ml-1 font-mono">{l.promotion_code}</span> : null}
                      {" · "}{l.promotion_type === "percent" ? `−${l.promotion_value_snapshot} %` : t("sp.typeFixed")}
                    </div>
                    <div>{t("sp.regularPrice")}: <span className="font-mono text-foreground">{money(l.promotion_base_price)}</span>
                      {" · "}{t("pv.discountAmount")}: <span className="font-mono text-foreground">{money(l.promotion_discount_amount)}</span></div>
                    {l.underlying_price_source && (
                      <div>{t("pv.underlying")}: <span className="text-foreground">{t(`pv.src.${l.underlying_price_source}`, l.underlying_price_source)}</span></div>
                    )}
                  </>
                )}
                {src === "customer_discount" && (
                  <div>{t("pv.src.customer_discount")}: <span className="text-foreground">{l.discount_percent} %</span></div>
                )}
                {src === "price_list" && l.price_list_id && (
                  <div>{t("pv.src.price_list")}: <span className="font-mono text-foreground">{l.price_list_id.slice(0, 8)}</span></div>
                )}
                {src === "manual_override" && canSell && (
                  <>
                    <div>{t("pv.calculated")}: <span className="font-mono text-foreground">{money(l.calculated_unit_price)}</span>
                      {" · "}{t("pv.applied")}: <span className="font-mono text-foreground">{money(l.overridden_unit_price ?? l.unit_price)}</span></div>
                    {l.override_reason && <div>{t("pv.reason")}: <span className="text-foreground">{l.override_reason}</span></div>}
                  </>
                )}
                <div>{t("pv.applied")}: <span className="font-mono text-foreground">{money(l.unit_price)}</span></div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="px-4 py-2 border-t border-border text-xs text-muted-foreground">{t("pv.hint")}</div>
    </div>
  );
};
